// extracted by mini-css-extract-plugin
module.exports = {"value":"value__33HuO","sub":"sub__1Cdp9"};